import React from 'react';
import { useDocumentManagement, DocumentAdminLink } from '../../features/legal/DocumentAdminAccess';
import LegalDocument from '../../features/legal/LegalDocument';
import AdminDocument from './TermsOfUseAdmin';
export default function TermsOfUse() {
  const managing = useDocumentManagement();
  return managing ? (
    <>
      <DocumentAdminLink editing />
      <AdminDocument />
    </>
  ) : (
    <LegalDocument type="terms" />
  );
}
